import type {
  LocalizedText,
  TravelFeature,
} from "@/app/api/utils/types/tenants";

/**
 * Colour for each card position, used when a tenant leaves a card's own colours
 * blank. The first card follows the tenant's primary colour through the CSS
 * variable the public layout sets.
 */
export const TRAVEL_FEATURE_PALETTE = [
  { bgColor: "rgb(var(--tenant-primary))", textColor: "#FFFFFF" },
  { bgColor: "#73ABFF", textColor: "#14141E" },
  { bgColor: "#9BF8DD", textColor: "#14141E" },
  { bgColor: "#C7FB6D", textColor: "#14141E" },
];

export const getTravelFeaturePalette = (index: number) =>
  TRAVEL_FEATURE_PALETTE[index % TRAVEL_FEATURE_PALETTE.length];

export const getLocalizedText = (
  text: LocalizedText | undefined,
  locale: string
): string => {
  if (!text) return "";
  return text[locale as keyof LocalizedText] || text.en || "";
};

export type ResolvedTravelFeature = {
  key: string;
  title: string;
  description: string;
  bgColor: string;
  textColor: string;
  iconUrl: string;
};

/**
 * Turns saved cards into what the card row renders. Every field falls back to
 * the position's default, so a half-filled card still looks deliberate.
 */
export const resolveTravelFeatures = (
  features: TravelFeature[],
  locale: string
): ResolvedTravelFeature[] =>
  features.map((feature, index) => {
    const palette = getTravelFeaturePalette(index);

    return {
      key: feature.id || String(index),
      title: getLocalizedText(feature.title, locale),
      description: getLocalizedText(feature.description, locale),
      bgColor: feature.bgColor || palette.bgColor,
      textColor: feature.textColor || palette.textColor,
      iconUrl: feature.iconUrl || "",
    };
  });
